{
  "titulo": "Auditoria",
  "entidades": {
    "empresa": "Empresa",
    "sucursal": "Filial",
    "deposito": "Depósito",
    "puesto_de_caja": "Caixa",
    "punto_de_venta": "Ponto de venda",
    "parametro": "Configuração",
    "rol": "Papel",
    "membresia": "Pessoa",
    "invitacion": "Convite",
    "sesion": "Sessão"
  },
  "acciones": {
    "alta": "Criação",
    "modificacion": "Alteração",
    "baja": "Desativação",
    "cambio_de_empresa": "Troca de empresa",
    "invitacion_aceptada": "Convite aceito"
  },
  "columnas": {
    "momento": "Quando",
    "quien": "Quem",
    "que": "O quê",
    "accion": "Ação",
    "desde": "De onde",
    "detalle": "Detalhe"
  },
  "detalle": {
    "antes": "Antes",
    "despues": "Depois",
    "sinCambios": "Sem dados registrados"
  },
  "filtros": {
    "todas": "Todas",
    "desdeFecha": "De",
    "hastaFecha": "Até"
  },
  "masResultados": "Ver mais",
  "descripcion": "Quem fez o quê, quando e de onde."
}
